import React from "react";
import { TableHead } from "./TableHead";
import { TableBody } from "./TableBody";
import { ResponsiveTable } from "../../../layout/Table/ResponsiveTable";

function TableComponent(props) {
  return (
  <ResponsiveTable>
      <TableHead
        applySort={props.applySort}
      />
      <TableBody
        tickets={props.tickets}
        actionCallback={props.actionCallback}
      />
    </ResponsiveTable>
  );
}

export { TableComponent };
